import image4 from '../../src/asset/image4.png';
import image5 from '../../src/asset/image5.png';
import image6 from '../../src/asset/image6.png';
import image7 from '../../src/asset/image7.png';
import image8 from '../../src/asset/image8.png';
import image9 from '../../src/asset/image9.png';

export default function Features() {
  const features = [
    {
      icon: image7,
      title: 'Real-time Monitoring',
      desc: 'Get real-time insights for each step — learn what worked, what didn’t, and the “why” behind every blockchain process.',
    },
    {
      icon: image5,
      title: 'Interactive Simulations',
      desc: 'Dive into the blockchain world with immersive simulations that provide immersive insights to build, mine, and validate blocks — as in a real network.',
    },
    {
      icon: image4,
      title: 'Practice Transactions',
      desc: 'Test your skills by mimicking real-life transactions and gain hands-on experience on how blocks are formed, verified, and added to the chain in real time.',
    },
    {
      icon: image6,
      title: 'Educational Hub',
      desc: 'Explore bite-sized lessons, quick guides, and interactive tutorials that make complex blockchain concepts simple and engaging.',
    },
    {
      icon: image8,
      title: 'Community Support',
      desc: 'Connect with fellow learners, exchange ideas, and grow together through a vibrant user community.',
    },
    {
      icon: image9,
      title: 'Customizable Roles',
      desc: 'Tweak user state/roles to experiment with how different participants in a blockchain contribute to the network.',
    },
  ];

  return (
    <section id="features" className="bg-[#0a0015] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Features
        </h2>
        <p className="text-white/60 mb-12 max-w-3xl">
          AstraPOS is your go-to for learning blockchain. Transactions, more
          interactive tools, practice simulations and resources await you in
          AstraPOS with ASTRAPOS.
        </p>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#4916CF]/10 border border-[#4916CF]/30 rounded-lg p-8 hover:bg-[#4916CF]/20 transition-colors"
            >
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-4 text-xl">
                <img
                  src={feature.icon}
                  alt={feature.title}
                  className="w-8 h-8"
                />
              </div>
              <h3 className="text-white font-bold mb-2 text-lg">
                {feature.title}
              </h3>
              <p className="text-white/60 text-sm">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
